import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { getHomeTokens } from '../getHomeTokens';
import { HOME_LAYOUT_SIZES } from '../homeTokens';

export interface HubStepBadgeProps {
  step: string;
}

export function HubStepBadge({ step }: HubStepBadgeProps): JSX.Element {
  const theme = useTheme();
  const homeTokens = getHomeTokens(theme);

  return (
    <Box
      sx={{
        width: HOME_LAYOUT_SIZES.stepBadgeSize,
        height: HOME_LAYOUT_SIZES.stepBadgeSize,
        borderRadius: '50%',
        border: `2px solid ${homeTokens.hubStepBadgeBorder}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <Typography
        sx={{
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: '20px',
          letterSpacing: '-0.1504px',
          color: homeTokens.hubStepBadgeColor,
        }}
      >
        {step}
      </Typography>
    </Box>
  );
}
